<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Generales" :breadcrumb="true" />
			</template>
			<template #actions>
				<div class="hstack gap-2 justify-content-md-end">
					<button type="button" class="btn btn-sm btn-neutral rounded-pill" @click="filter"><i class="bi bi-funnel pe-1"></i>Filtros</button>
				</div>
			</template>
		</LayoutHeaderSection>
		<LayoutTabMain ref="tab" :options="{ states: 'Estados', reconquest: 'Reconquistas', sales: 'Ventas' }" />
		<main class="py-5 vstack gap-3" v-if="!loading">
			<div class="card" v-if="tab.selected == 'states'">
				<div class="card-header">
					<h5 class="mb-0">Estados por día</h5>
				</div>
				<div class="card-body vstack gap-5">
					<CompanyAdminReportCommonGraphStatus title="Totalizados" :filters="results.filters" :totals="results.totals?.histories ?? []" />
					<div v-for="(data, index) in results.users" v-bind:key="index">
						<hr class="mx-n4" />
						<CompanyAdminReportCommonGraphStatus :title="data.data.name" :filters="results.filters" :totals="data?.histories ?? []" />
					</div>
				</div>
			</div>
			<div class="card" v-if="tab.selected == 'reconquest'">
				<div class="card-header">
					<h5 class="mb-0">Reconquistas por día</h5>
				</div>
				<div class="card-body vstack gap-5">
					<CompanyAdminReportCommonGraphReconquest title="Totalizados" :filters="results.filters" :totals="results.totals?.reconquests ?? []" />
					<div v-for="(data, index) in results.users" v-bind:key="index">
						<hr class="mx-n4" />
						<CompanyAdminReportCommonGraphReconquest :title="data.data.name" :filters="results.filters" :totals="data?.reconquests ?? []" />
					</div>
				</div>
			</div>
			<div class="card" v-if="tab.selected == 'sales'">
				<div class="card-header">
					<h5 class="mb-0">Ventas por día</h5>
				</div>
				<div class="card-body vstack gap-5">
					<CompanyAdminReportCommonGraphSale title="Totalizados" :filters="results.filters" :totals="results.totals?.sales ?? []" />
					<div v-for="(data, index) in results.users" v-bind:key="index">
						<hr class="mx-n4" />
						<CompanyAdminReportCommonGraphSale :title="data.data.name" :filters="results.filters" :totals="data?.sales ?? []" />
					</div>
				</div>
			</div>
		</main>

		<CommonModalFilter ref="modalFilter" title="Filtros de la estadística" @success="getResults">
			<CommonFormInputDateRange v-model:from="filters.start_date" v-model:to="filters.end_date" title="Rango de fechas" placeholder="Seleccionar fechas" />
		</CommonModalFilter>
	</div>
</template>

<script>
	import { ref, reactive, onMounted } from 'vue';
	import router from '@/router';
	import _ from 'lodash';
	import moment from 'moment';
	import composableForm from '@/composables/form';
	import CompanyAdminReportRepository from '@/repositories/modules/Company/Admin/Report';

	export default {
		setup() {
			const { loading, catchError } = composableForm();
			const tab = ref(null);
			const results = ref({});

			const filters = reactive({
				start_date: moment().subtract(6, 'days').toDate(),
				end_date: moment().toDate()
			});

			const getResults = async () => {
				loading.value = true;

				await CompanyAdminReportRepository.general(filters).then((response) => {
					results.value = response.data;
				}).catch((e) => {
					catchError(e, true);
					router.push({ name: 'company.admin.home' });
				});

				loading.value = false;
			}

			const modalFilter = ref(null);
			const filter = () => modalFilter.value.show();

			onMounted(getResults);

			return { loading, tab, filters, results, modalFilter, filter, getResults };
		}
	}
</script>